export const getDialogStyles = (colors) => ({
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: colors.overlay,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 2000,
  },
  dialog: {
    backgroundColor: colors.surface,
    padding: '24px',
    borderRadius: '16px',
    maxWidth: '90%',
    width: '400px',
    boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
  },
  menuGrid: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  menuButton: {
    display: 'flex',
    alignItems: 'center',
    padding: '12px 16px',
    border: 'none',
    borderRadius: '12px',
    backgroundColor: colors.button,
    color: colors.buttonText,
    cursor: 'pointer',
    width: '100%',
    transition: 'background-color 0.2s',
  },
  menuIcon: {
    fontSize: '24px',
    marginRight: '16px',
    width: '24px',
    textAlign: 'center',
  },
  menuText: {
    fontSize: '16px',
    color: colors.text,
    textAlign: 'left',
    flex: 1,
  },
  selectContainer: {
    marginBottom: '16px',
  },
  selectLabel: {
    display: 'block',
    fontSize: '16px',
    color: colors.text,
    marginBottom: '4px',
    textAlign: 'center',
    fontWeight: '500',
  },
  select: {
    width: '100%',
    padding: '12px 16px',
    border: `2px solid ${colors.border}`,
    borderRadius: '12px',
    fontSize: '16px',
    backgroundColor: colors.button,
    color: colors.buttonText,
    appearance: 'none',
    cursor: 'pointer',
    outline: 'none',
  },
  closeButton: {
    display: 'block',
    width: '100%',
    padding: '12px',
    border: 'none',
    borderRadius: '25px',
    cursor: 'pointer',
    fontSize: '16px',
    fontWeight: '500',
    backgroundColor: colors.button,
    color: colors.buttonText,
    marginTop: '16px',
  },
  subMenu: {
    backgroundColor: colors.button,
    padding: '16px',
    borderRadius: '12px',
    marginTop: '8px',
  },
  backButton: {
    display: 'flex',
    alignItems: 'center',
    padding: '12px 16px',
    border: 'none',
    borderRadius: '12px',
    backgroundColor: colors.button,
    color: colors.buttonText,
    cursor: 'pointer',
    width: '100%',
    marginBottom: '16px',
  },
  step: {
    display: 'flex',
    alignItems: 'center',
    padding: '8px 0',
    fontSize: '16px',
    color: colors.text,
  },
  stepNumber: {
    width: '24px',
    height: '24px',
    borderRadius: '12px',
    backgroundColor: colors.border,
    color: colors.text,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: '12px',
    fontSize: '14px',
  }
});
